<template>
  <div class="appContainer top_container">
    <div class="title">
      <div class="line"></div>
      <h1>
        {{ $t('list-company-page.favorite-company', { split: '/' }) }}
      </h1>
    </div>

    <div class="list_company">
      <CompanyCardPreview
        :item="companyInfoDetail"
        pclass="company_card"
        type="unlike"
      />
    </div>

    <hr class="hr-line" />

    <div class="title mt-4">
      <div class="line"></div>
      <h1>{{ $t('list-company-page.list-company', { split: '/' }) }}</h1>
    </div>

    <div class="list_company">
      <CompanyCardPreview
        :item="companyInfoDetail"
        pclass="company_card"
        type="like"
      />
    </div>

    <ScrollTopBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompanyCardPreview from '@/components/entry/preview/CompanyCardPreview';
import ScrollTopBtn from '@/components/ScrollTopBtn';

import './listCompany.scss';

import { TYPE_GRID, TYPE_TABLE } from '@/common/constants';

export default {
  name: 'listCompany',
  components: {
    CompanyCardPreview,
    ScrollTopBtn
  },

  data: function () {
    return {
      listCompanyShowType: TYPE_TABLE,

      optionTypes: [
        {
          name: 'top-page.show-type.type-grid',
          value: TYPE_GRID
        },
        {
          name: 'top-page.show-type.type-table',
          value: TYPE_TABLE
        }
      ]
    };
  },

  created() {
    const { query } = this.$route;

    if (typeof query.token !== 'undefined') {
      this.$store.dispatch('previewCompany', {
        company_token: query.token
      });
    }
  },

  methods: {},
  computed: {
    ...mapGetters({
      companyInfoDetail: 'getCompanyInfoDetail'
    })
  },

  watch: {
    companyInfoDetail: function (val) {}
  }
};
</script>

<style>
.hr-line {
  margin-top: 10px;
  margin-bottom: 30px;
  width: 100%;
  border-top: 1px dashed #00a2ff;
}
</style>
